<template>
    <form @submit.prevent="onSubmit">
        <div class="form-group"
             v-for="creditPackage in creditPackages"
             :key="creditPackage.id"
        >
            <label>Plano #{{ creditPackage.id }}</label>
            <!--div class="flex-row">
                <h4 class="m-l m-r">PagSeguro ID</h4>
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.payment_plan_id"
                    :disabled="true"
                ></p>
            </div-->

            <div class="flex-row">
                <h4 class="m-l m-r">Tipo</h4>
                <div class="form-group" :class="{ 'has-error': form.errors.has('payment_limit_opt_menu') }">
                    <select name="payment_limit_opt_menu" class="form-control" v-model="creditPackage.payment_limit_opt_menu" required>
                        <option value="0">Starter</option>
                        <option value="1">Master</option>
                        <option value="2">Premium</option>
                        <option value="3">Captação de Clientes</option>
                    </select>
                </div>
            </div>

            <div class="flex-row">
                <h4 class="m-l m-r">Nome </h4>
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.payment_plan_name"
                    :disabled="true"
                ></p>

                <!--
                <h4 class="m-l m-r">Trial </h4>
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.payment_trial_period"
                    :disabled="true"
                ></p>
                -->
            </div>

            <div class="flex-row">

                <!--
                <h4 class="m-l m-r">Dias Val Creditos </h4>
                <div class="form-group"
                    :class="{ 'has-error': form.errors.has('amount_validity') }">
                    <input type="number"
                        class="form-control"
                        v-text="creditPackage.amount_validity"
                        v-model="creditPackage.amount_validity"
                        placeholder="Dias validade creditos"
                        :disabled="true"
                    >
                </div>
                -->

                <h4 class="m-l m-r">Qt Users </h4>
                <div class="form-group"
                    :class="{ 'has-error': form.errors.has('payment_total_users') }">
                    <input type="number"
                        class="form-control"
                        v-text="creditPackage.payment_total_users"
                        v-model="creditPackage.payment_total_users"
                        placeholder="Total Usuários"
                    >
                </div>

                <h4 class="m-l m-r">Ordem Apres. </h4>
                <div class="form-group"
                    :class="{ 'has-error': form.errors.has('payment_plan_show_order') }">
                    <input type="number"
                        class="form-control"
                        v-text="creditPackage.payment_plan_show_order"
                        v-model="creditPackage.payment_plan_show_order"
                        placeholder="Ordem apresentacao"
                    >
                </div>
            </div>

            <div class="flex-row">
                <h4 class="m-l m-r">Créditos </h4>
                <div class="form-group"
                    :class="{ 'has-error': form.errors.has('amount') }">
                    <input type="number"
                        class="form-control"
                        v-text="creditPackage.amount"
                        v-model="creditPackage.amount"
                        placeholder="Créditos recorrente"
                    >
                </div>

                <h4 class="m-l m-r">FULL</h4>
                <div class="form-group"
                    :class="{ 'has-error': form.errors.has('price_full') }">
                    <input type="number"
                        class="form-control"
                        v-text="creditPackage.price_full"
                        v-model="creditPackage.price_full"
                        placeholder="R$ SEM Desconto"
                    >
                </div>
                <h4 class="m-l m-r">%</h4>
                <div class="form-group"
                    :class="{ 'has-error': form.errors.has('discount') }">
                    <input type="number"
                        class="form-control"
                        v-text="creditPackage.discount"
                        v-model="creditPackage.discount"
                        placeholder="Desconto"
                    >
                </div>
            </div>

            <div class="flex-row">
                <h4 class="m-l m-r">Gestão</h4>
                <div class="form-group" :class="{ 'has-error': form.errors.has('payment_plan_management') }">
                    <select name="payment_plan_management" class="form-control" v-model="creditPackage.payment_plan_management" required>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                </div>

                <h4 class="m-l m-r">Publicações</h4>
                <div class="form-group" :class="{ 'has-error': form.errors.has('payment_plan_publication') }">
                    <select name="payment_plan_publication" class="form-control" v-model="creditPackage.payment_plan_publication" required>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                </div>
            </div>

            <div class="flex-row">
                <h4 class="m-l m-r">R$ Pacote</h4>
                <p type="text"
                    class="form-control"
                    v-text="creditPackage.price"
                    :disabled="true"
                ></p>
                <button class="btn btn-default m-l m-b-sm"
                        type="button"
                        @click="changeVisibility(creditPackage)"
                > <i v-if="creditPackage.visible" class="fa fa-eye"></i>
                    <i v-else="creditPackage.visible" class="fa fa-eye-slash"></i>
                </button>
                <button class="btn btn-warning m-l m-b-sm"
                        type="button"
                        @click="updatePackage(creditPackage)"
                >U</button>
                <button class="btn btn-danger m-l m-b-sm"
                        type="button"
                        @click="deletePackage(creditPackage)"
                >x</button>
            </div>
        </div>

        <!-- NOVO PLANO -->
        <label>NOVO PLANO ##</label>

        <div class="flex-row">
            <h4 class="m-l m-r">Tipo</h4>
            <div class="form-group" :class="{ 'has-error': form.errors.has('payment_limit_opt_menu') }">
                <select name="payment_limit_opt_menu" class="form-control" v-model="form.payment_limit_opt_menu" required>
                    <option value="0">Starter</option>
                    <option value="1">Master</option>
                    <option value="2">Premium</option>
                    <option value="3">Captação de Clientes</option>
                </select>
            </div>
        </div>

        <div class="flex-row">
            <h4 class="m-l m-r">Nome</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('payment_plan_name') }">
                <input type="text"
                    class="form-control"
                    v-model="form.payment_plan_name"
                    placeholder="Nome do Plano"
                >
            </div>
            
            <!--
            <h4 class="m-l m-r">Trial</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('payment_trial_period') }">
                <input type="number"
                    class="form-control"
                    v-model="form.payment_trial_period"
                    placeholder="Periodo de testes"
                >
            </div>
            -->

            <!--
            <h4 class="m-l m-r">0-NoLimit 1-Limit</h4>
            <div class="form-group"
                :class="{ 'has-error': form.errors.has('payment_limit_opt_menu') }">
                <input type="number"
                    class="form-control"
                    v-model="form.payment_limit_opt_menu"
                    min="0"
                    max="1"
                    placeholder="Limita Acesso"
                >
            </div>
            -->
        </div>
         <div class="flex-row">

            <!--
            <h4 class="m-l m-r">Dias Val Creditos</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('amount_validity') }">
                <input type="number"
                    class="form-control"
                    v-model="form.amount_validity"
                    placeholder="Dias validade creditos"
                    :disabled="true"
                >
            </div>
            -->

            <h4 class="m-l m-r">Qt Users</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('payment_total_users') }">
                <input type="number"
                    class="form-control"
                    v-model="form.payment_total_users"
                    placeholder="Total Usuários"
                >
            </div>
            <h4 class="m-l m-r">Ordem Apres.</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('payment_plan_show_order') }">
                <input type="number"
                    class="form-control"
                    v-model="form.payment_plan_show_order"
                    placeholder="Ordem apresentacao"
                >
            </div>
        </div>
        <div class="flex-row">
            <h4 class="m-l m-r">Creditos</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('amount') }">
                <input type="number"
                    class="form-control"
                    v-model="form.amount"
                    placeholder="Créditos recorrente"
                >
            </div>

            <h4 class="m-l m-r"></h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('price_full') }">
                <input type="text"
                       placeholder="R$ SEM Desconto"
                       class="form-control"
                       v-model="form.price_full"
                >
            </div>
            <h4 class="m-l m-r"></h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('discount') }">
                <input type="text"
                       placeholder="% Desconto"
                       class="form-control"
                       v-model="form.discount"
                >
            </div>
        </div>

        <div class="flex-row">
            <h4 class="m-l m-r">Gestão</h4>
            <div class="form-group" :class="{ 'has-error': form.errors.has('payment_plan_management') }">
                <select name="payment_plan_management" class="form-control" v-model="form.payment_plan_management" required>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                </select>
            </div>

            <h4 class="m-l m-r">Publicações</h4>
            <div class="form-group" :class="{ 'has-error': form.errors.has('payment_plan_publication') }">
                <select name="payment_plan_publication" class="form-control" v-model="form.payment_plan_publication" required>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                </select>
            </div>
        </div>

        <div class="flex-row">
            <h4 class="m-l m-r">R$</h4>
            <div class="form-group"
                 :class="{ 'has-error': form.errors.has('price') }">
                <input type="text"
                       placeholder="Valor do pacote"
                       class="form-control"
                       v-model="form.price"
                >
            </div>
            <button class="btn btn-primary m-l m-b"
                        type="button"
                        @click="onSubmit"
                >x</button>
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-md btn-primary">Adicionar Novo</button>
        </div>
    </form>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: {
        partnership: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            creditPackages: [],
            form: new Form({
                amount: null,
                price: null,
                amount_validity:90,
                payment_plan_name:null,
                payment_method_type:1,
                payment_charge:1,
                payment_period:1,
                payment_trial_period:0,
                payment_total_users:0,
                payment_limit_opt_menu:0,
                payment_plan_show_order:null,
                partnership_id: null,
                price_full:null,
                discount:null,
                payment_plan_publication:0,
                payment_plan_management:1
            }),
        };
    },
    mounted() {
        this.loadCreditPackages();
    },
    methods: {
        loadCreditPackages() {
            this.form.partnership_id = this.partnership.id;

            axios.get(`/credit-packages-recurrent/${this.partnership.id}/partnership`)
                .then(({data}) => {
                    this.creditPackages = data;
                });
        },
        onSubmit() {
            this.form.post('/credit-packages-recurrent')
                .then(() => {
                    this.loadCreditPackages();
                });
        },
        updatePackage(creditPackage) {
            axios.patch(`/credit-packages-recurrent/${creditPackage.id}`, {
                amount: creditPackage.amount,
                price: creditPackage.price,
                amount_validity:creditPackage.amount_validity,
                payment_plan_name:creditPackage.payment_plan_name,
                payment_method_type:creditPackage.payment_method_type,
                payment_charge:creditPackage.payment_charge,
                payment_period:creditPackage.payment_period,
                payment_trial_period:creditPackage.payment_trial_period,
                payment_total_users:creditPackage.payment_total_users,
                payment_limit_opt_menu:creditPackage.payment_limit_opt_menu,
                payment_plan_show_order:creditPackage.payment_plan_show_order,
                price_full: creditPackage.price_full,
                discount: creditPackage.discount,
                payment_plan_publication:creditPackage.payment_plan_publication,
                payment_plan_management:creditPackage.payment_plan_management
            }).then(() => {
                toastr.success('Pacote atualizada com sucesso');
            })
            .catch(() => {
                toastr.error('Erro ao atualizar pacote recorrente');
            });
        },
        deletePackage(creditPackage) {
            axios.delete(`/credit-packages-recurrent/${creditPackage.id}`)
                .then(() => {
                    this.loadCreditPackages();
                })
                .catch(() => {
                    toastr.error('Erro ao excluir o pacote recorrente');
                });
        },
        changeVisibility(creditPackage) {
            axios.post(`/credit-packages-recurrent/${creditPackage.id}/visibility`)
                .then(() => {
                    this.loadCreditPackages();
                })
                .catch(() => {
                    toastr.error('Erro ao mudar o pacote recorrente');
                });
        }
    },
}
</script>
